import React from "react"
import CCardFactImage from "../elements/c_card_fact_image"
import Section from "./section";
import DfbHeadline from "../ui-kit/dfb_headline"

const MCardFactImage = ({ data }) => {
  const { headline, subheadline, image, facts, layout } = data
  const img = image?.[0]
  const fact = facts?.[0]
  const href = fact?.link_typo3_type === "email" ?  "mailto:" + fact?.facts_link : fact?.facts_link
  const linkObj = fact?.link_typo3_type !== 'email' ? fact?.facts_link_obj : null

  if (!fact) {
    return null
  }

  return (
    <Section baseClass="m-CardFactImage" defaultPadding="large" data={data}>
      <div className="m-CardFactImage-wrapper">
        <div className="m-CardFactImage-container">
          <div className="m-CardFactImage-content">
            {headline && <DfbHeadline
              headline_level="h2"
              headline={headline}
              add_class="m-CardFactImage-headline"
            />}
            {subheadline && <div className="m-CardFactImage-headline">{subheadline}</div>}
            <CCardFactImage
              image={img}
              layout={layout}
              type={fact?.facts_layout}
              headline={fact?.facts_headline}
              subline={fact?.facts_sub_headline}
              icon={fact?.facts_icon}
              description={fact?.facts_text}
              anchor={fact?.facts_link_text}
              href={href}
              linkObj={linkObj}
            />
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MCardFactImage
